import React, { useState, useEffect } from 'react';
import Widget from "../StatsWidget/Widget";
import LineItemWidget from '../StatsWidget/LineItemWidget';
import BarGraphWidget from "../StatsWidget/BarGraphWidget";

const Dashboard = ({dashboardPath, setSpinning, isSubChannel, screeningChannel}) => {
  const [data, setData] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    setSpinning(true)
    $.ajax({
      type: 'GET',
      url: dashboardPath,
      success: function(data) {
        setData(data)
        setSpinning(false)
      }
    });
  }

  const renderTogglerMessage = () => {
    if (data.channel_admins.length < 4 && data.deputy_editors.length < 4) {
      return
    }

    var caratClass = expanded ? "fa fa-angle-up" : "fa fa-angle-down"

    return (
      <div className="content-toggler" id="expand-trigger-wrap">
        <a onClick={ () => setExpanded(!expanded) }>
          <i className={ caratClass }></i>
        </a>
      </div>
    )
  }

  const renderEditors = (editors) => {
    let newEditors = !expanded ? editors.slice(0, 3) : editors
    return newEditors.map(editor => {
      return (
        <div className="row editor-row" key={editor.id}>
          <div className="small-5 columns no-padding" key={editor.id}><a href={editor.user_path} target="_blank">{editor.full_name}</a></div>
          <div className="small-7 columns offset-1 no-padding" key={editor.id+1}><a href={`mailto:${editor.email}`}>{editor.email}</a></div>
        </div>
      )
    })
  }

  const renderWidgetStats = () => {
    if(data) {
      return (
        <div className="widget-container">
          <Widget {...JSON.parse(data.publishedContent)} isChannelDashboard={true} />
          <Widget {...JSON.parse(data.contentEngagement)} isChannelDashboard={true} displayFlex={true}/>
          <BarGraphWidget {...JSON.parse(data.channelTimeToPublish)} isChannelDashboard={true} />
          <small>**Some data is unavailable if date range is too large or unavailable</small>
        </div>
      )
    }
  }

  const publishedContractDataText = () => {
    const { publishedFromContractDate, yearlyContractedArticles, formattedDateRange } = data;
    if (typeof publishedFromContractDate === 'number') {
      const totalPublished = publishedFromContractDate > yearlyContractedArticles ? <strong>{publishedFromContractDate}</strong> : publishedFromContractDate
      return (
        <p>{totalPublished} out of {yearlyContractedArticles} articles published in current contract period ({formattedDateRange})</p>
      )
    }
  }

  const guideLinks = () => {
    if (isSubChannel) {
      return {
        channelAdmin: "https://docs.google.com/document/d/1dpscO-TV27LJgLA8YvwaYvx1z5KNbWD_G_csATSVc9Y/edit?tab=t.0#heading=h.zhmsy7r0ppm1",
        deputyEditor: "https://docs.google.com/document/d/1U-54PHdQsOJAiSWzWvZbYB8T3XHyD_SUzcfBH4I831Q/edit?tab=t.0#heading=h.zhmsy7r0ppm1"
      }
    } else {
      return {
        channelAdmin: "https://docs.google.com/document/d/1ca3hLQWkvHMfRoBZU_7QS4qeUqSdekqGLagFopCAow4/edit?usp=drive_link",
        deputyEditor: "https://docs.google.com/document/d/1Mxy0nrFip7d_Reaw-y4eA8FDRXiYrMgZsrX7uZT2Lis/edit?usp=drive_link"
      }
    }
  }

  if (!data) {
    return <div/>
  } else {
    return (
      <React.Fragment>
        <div className="dashboard-container">
          <div className="row">
            <div className="small-12 columns">
              <h3 className="dashboard-stat-title">{data.name}</h3>
              {!screeningChannel && <p className="checklist-blurb">
                <a href="https://docs.google.com/document/d/16n__m22GsJOLFLPof5zhtbAXP3sEDzXrjb4Lgxmh8QU/edit?usp=sharing" target="_blank">First and Second Channel Preview Checklists</a>&nbsp;(For channel use during review of article submissions.)
              </p>}
            </div>
          </div>
          <div className="row channel-metrics-container">
            <div  className="small-3 columns border-right">
              <h6>Channel Overview</h6>
              {data.published_at &&
                <p>
                  Launched {data.published_at}
                </p>
              }
              {publishedContractDataText()}
              <p>
                {data.published} content published (all time)
              </p>
              <p>
                {data.active} in progress
              </p>
            </div>
            <div className="small-9 columns">
              <div className="row admin-editors-container">
                <div className={`small-6 columns border-right pad channel-administrators  ${screeningChannel ? 'no-border' : ''}`} >
                  <h6 className="channel-users-header">{screeningChannel ? "Channel Screeners" : "Channel Administrators"}</h6>&nbsp;
                  {!screeningChannel && <a className="guide-link" href={guideLinks()['channelAdmin']} target="_blank">(Channel Admin Guide)</a>}
                  <div>
                    {!screeningChannel && renderEditors(data.channel_admins)}
                    {screeningChannel && renderEditors(data.channel_screeners)}
                  </div>
                </div>

                <div  className="small-6 columns pad">
                  {!screeningChannel && <><h6 className="channel-users-header">Channel Curators</h6>&nbsp;
                  <a className="guide-link" href={guideLinks()['deputyEditor']} target="_blank">(Channel Curator Guide)</a>
                  <div>
                    {data.deputy_editors && renderEditors(data.deputy_editors)}
                    {data.deputy_editors.length == 0 && <span>&#8212;</span>}
                  </div></>}
                </div>
              </div>

              {renderTogglerMessage()}

            </div>
          </div>
          {renderWidgetStats()}
        </div>
      </React.Fragment>
    )
  }
}

export default Dashboard;